import React from "react";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import withRouter from "../../../../../withRouter";
import BaseListPage from "../../../../../base/BaseListPage";
import ApEarningsPresenter from "./ApEarningsPresenter";
import TablePayroll from "../../../Payroll/table-payroll/TablePayroll";
import Progress from "../../../../../components/Progress";

class ApEarningsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      objects: [],
      tableHeaders: {},
      isLoading: true,
    };
    this.presenter = new ApEarningsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "payroll";
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, tableHeaders, isLoading } = this.state;
    const { fetchPayrolls } = this.props;

    console.log("fetchPayrolls", fetchPayrolls);
    console.log("tableHeaders", tableHeaders);

    if (!schema) return <Progress />;
    const tableObjects = [
      {
        payrollPeriod: "January 1, 2025 - January 2, 2025",
      },
      {
        noOfDays: 23,
      },
    ];

    return (
      <>
        <div className="p-3 mt-4">
          <TablePayroll
            tableHeader={tableHeaders?.tableHeader}
            primarySubHdr={tableHeaders?.primarySubHdr}
            headersKey={tableHeaders?.convertedHeaders}
            isValueOnly={true}
            isLoading={isLoading}
            object={objects}
          />
        </div>
      </>
    );
  }
}

export default withRouter(ApEarningsPage);
